module.exports = __webpack_public_path__ + "img/ambrpay.1e29f961.png";